$(() => {
	$('#main-nav').hcOffcanvasNav({
		maxWidth: 768,
		labelBack: 'Voltar',
		labelClose: 'Fechar',
		navTitle: 'Nova Ubiratã',
		customToggle: '.menu-mobile-button'
	});

	// Verifica hash ao iniciar
	URI.init();

	(<any>$('#p5fw-accessibility-buttons')).p5fwAccessibility();

	//PopUP's
	if ($('#popupModal').length === 1) {
		(<any>$('#popupModal')).modal('show');
	}

	/*Search*/
	$('#search-btn').click(function() {
		var search: any = $('#search').val();
		if (search.length > 2) {
			window.location.href = '/#/search/' + encodeURIComponent(search);
		}
	});

	$('#search').keyup(function(event: any) {
		if (event.keyCode == 13) {
			$('#search-btn').click();
		}
	});

	$('#search-btn-m').click(function() {
		var search: any = $('#search-m').val();
		if (search.length > 2) {
			window.location.href = '/#/search/' + encodeURIComponent(search);
		}
	});

	$('#search-m').keyup(function(event: any) {
		if (event.keyCode == 13) {
			$('#search-btn-m').click();
		}
	});

	$('#search-m').click(function(event: any) {
		event.stopPropagation();
	});

	// Back To TOP
	$(document).scroll(function() {
		var y = $(this).scrollTop();
		if (y > 400) {
			$('#footer-btn-back-top').fadeIn();
		} else {
			$('#footer-btn-back-top').fadeOut();
		}
	});

	$('#footer-btn-back-top').click(function() {
		$('body, html').animate({ scrollTop: 0 }, 900);
	});
});
